import { localize } from "vee-validate";

export function setVeeLocale(code) {
  return import(`vee-validate/dist/locale/${code}.json`).then((locale) => {
    localize(code, locale);
  });
}

export function truncator(string, length, end = "...") {
  return string
    ? string.length < length
      ? string
      : string.substring(0, length) + end
    : "";
}

export function capitalizeFirstLetter(str) {
  return str ? str[0].toUpperCase() + str.slice(1) : "";
}

export function toLowerCase(string) {
  return (string || "").toLowerCase();
}

export function formatCurrency(value) {
  return new Intl.NumberFormat(this.locale, {
    style: "currency",
    currency: this.currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);
}

export function escapeHtml(value) {
  if (!value) return "";

  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function toLocalDateTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
}

export function toUtcIsoDateTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toISOString();
}

export function toNumber(value) {
  if (value === null || value === undefined) return 0;
  if (typeof value === "number") return value;

  const normalizedValue = String(value).replace(/,/g, "").trim();
  const parsedValue = Number(normalizedValue);

  return Number.isNaN(parsedValue) ? 0 : parsedValue;
}

export function resolveQuoteServiceTypeId(
  selectedServiceTypeId,
  stateServiceTypeOrigin
) {
  if (selectedServiceTypeId) {
    return selectedServiceTypeId;
  }

  if (
    Array.isArray(stateServiceTypeOrigin) &&
    stateServiceTypeOrigin[0] &&
    stateServiceTypeOrigin[0].type
  ) {
    return stateServiceTypeOrigin[0].type;
  }

  return null;
}

/**
 * Flota Ridery Corporativo (CR-607): se puede cotizar y pedir aunque no haya
 * conductores cerca. El despacho busca con las reglas del corporativo ronda
 * tras ronda, así que lo peor es que espere a que se libere uno.
 */
export function canRequestWithoutNearbyDrivers(serviceTypeOptions, serviceTypeId) {
  if (!Array.isArray(serviceTypeOptions) || !serviceTypeId) return false;
  const option = serviceTypeOptions.find((item) => item._id === serviceTypeId);
  return Boolean(option && option.is_custom_corporate_fleet);
}

// `pinImageUrl`: pin propio de la flota (hoy sólo la Flota Ridery
// Corporativo, CR-607); null = el carro por defecto del mapa.
export function mapNearbyProvidersByServiceType(
  providers,
  serviceTypeId,
  pinImageUrl = null,
) {
  if (!Array.isArray(providers) || !serviceTypeId) {
    return null;
  }

  const mappedProviders = providers
    .filter(
      (provider) =>
        Array.isArray(provider.providerLocation) &&
        provider.providerLocation.length >= 2
    )
    .map((provider) => ({
      type: serviceTypeId,
      bearing: provider.bearing,
      picture: provider.picture,
      lat: parseFloat(provider.providerLocation[0]),
      lng: parseFloat(provider.providerLocation[1]),
      pin_image_url: pinImageUrl,
    }));

  return mappedProviders.length > 0 ? mappedProviders : null;
}
